export default __webpack_public_path__ + "static/media/img_step_5.c19ca396.svg";